import React, { createContext, useState, useEffect } from 'react'
import {
  Loading,
  MenuBar,
  Hamburger,
  ContactModal,
  EbookModal,
  // WorkModal,
  LanguageProvider,
} from '~/components'
import { TransitionProvider, TransitionViews } from 'gatsby-plugin-transitions'
import { PageProps } from 'gatsby'
import { Hero } from '~/sections'
import '@fil1pe/react-slider/style.css'

interface Context {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  openContactModal: (openWhatsApp?: boolean) => void
  openEbookModal: () => void
  // openWorkModal: () => void
  openHamburger: () => void
  openWhatsApp: boolean
  setOpenWhatsApp: React.Dispatch<React.SetStateAction<boolean>>
}

export const context = createContext<Context>(null)

const layout = (loadingDefault: boolean, { children, location }: PageProps) => {
  const [loading, setLoading] = useState(loadingDefault)
  const [loadingActive, setLoadingActive] = useState(loadingDefault)
  const [hamburgerOpen, setHamburgerOpen] = useState(false)
  const [contactModalOpen, setContactModalOpen] = useState(false)
  const [ebookModalOpen, setEbookModalOpen] = useState(false)
  const [openWhatsApp, setOpenWhatsApp] = useState(false)
  // const [workModalOpen, setWorkModalOpen] = useState(false)

  const [enterOpacity, setEnterOpacity] = useState(0.9999)
  useEffect(() => {
    setEnterOpacity(0)
    // if (location.pathname === '/dvert/acompanhe-a-obra/') setWorkModalOpen(true)
  }, [])

  const isHomePage = !['/sucesso', '/success', '/exito', '/404'].includes(
    location.pathname.replace(/\/$/, '')
  )

  const openContactModal = (openWhatsApp?: boolean) => {
    setOpenWhatsApp(openWhatsApp)
    setContactModalOpen(true)
  }

  return (
    <>
      {loading && <Loading active={loadingActive} />}
      <LanguageProvider>
        <context.Provider
          value={{
            setLoading: (value: boolean) => {
              if (value) {
                setLoading(true)
                setLoadingActive(true)
                setTimeout(() => setLoading(false), 500)
              } else {
                setLoadingActive(false)
                setTimeout(() => setLoading(false), 500)
              }
            },
            openHamburger: () => {
              setHamburgerOpen(true)
            },
            openContactModal,
            openEbookModal: () => setEbookModalOpen(true),
            // openWorkModal: () => setWorkModalOpen(true),
            openWhatsApp,
            setOpenWhatsApp,
          }}
        >
          {isHomePage && <Hero />}
          {isHomePage && <MenuBar />}
          <Hamburger
            open={hamburgerOpen}
            onClose={() => setHamburgerOpen(false)}
          />
          <ContactModal
            open={contactModalOpen}
            onClose={() => setContactModalOpen(false)}
          />
          <EbookModal
            open={ebookModalOpen}
            onClose={() => setEbookModalOpen(false)}
          />
          {/* <WorkModal
            open={workModalOpen}
            onClose={() => setWorkModalOpen(false)}
          /> */}
          <TransitionProvider
            location={location}
            mode="immediate"
            enter={{
              opacity: enterOpacity,
            }}
            usual={{
              opacity: 1,
            }}
            leave={{
              opacity: 0,
              config: {
                duration: 200,
              },
            }}
          >
            <TransitionViews>{children}</TransitionViews>
          </TransitionProvider>
        </context.Provider>
      </LanguageProvider>
    </>
  )
}

export default (props: PageProps) => {
  const context = props.pageContext as { [key: string]: never }
  if (context?.layout === '404') return layout(true, props)
  return layout(false, props)
}
